	export enum LastAttachmentSourceEnum {
		SaleOrder = 1,
		Patient = 2,
		Appointment = 3
	}
